import { Injectable } from "@angular/core";
@Injectable()
export class ProfessionVerificationStatusModel{
    Pending = 'Pending';
    Verified = <any> 'Verified';
    Unverified = <any> 'Unverified';
    MoreInfoRequired = <any> 'MoreInfoRequired';
}